<template>
    <div class="form-row">
        <div class="col-12 col-lg-10">
            <input id="new_comment" @keyup="check_enter" v-model="comment" class="form-control small" type="text">
        </div>
        <div class="w-100 p-1 d-md-none"></div>
        <div class="col-12 col-lg-2">
            <button @click="add_comment" class="form-control btn btn-outline-success">Saugoti komentarą</button>
        </div>

    </div>
</template>

<script>
    export default {
        name: "NewComment",
        props: [
            'customer_id',
            'offer_id',
            'user_id'
        ],
        data() {
            return {
                comment: ''
            }
        },
        methods: {
            add_comment(){
                // console.log(this._data);
                let form = {};
                if(this._data.comment == ''){ return; }
                form.comment =  this._data.comment;
                form.customer_id = this.$props.customer_id;
                form.offer_id = this.$props.offer_id;
                form.user_id = this.$props.user_id;
                console.log(form);
                axios.post('/add_comment', form )
                    .then(response => {
                        if(response.status == 200){
                            window.location.reload();
                        }
                    })
            },

            check_enter(e){
                // console.log('enter');
                if(e.keyCode === 13){
                    this.add_comment();
                }
            }
        }
    }
</script>

<style scoped>

</style>